// import Box from "@mui/material/Box";
// import List from "@mui/material/List";
// import ListItem from "@mui/material/ListItem";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemText from "@mui/material/ListItemText";
// import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
// import { useLocation, useNavigate } from "react-router-dom";
// import CreditCardIcon from "@mui/icons-material/CreditCard";
// import { Divider } from "@mui/material";
// import { FaFileInvoice, } from "react-icons/fa";
// import logo from "../../../assets/inventory-logo.jpeg";
// import InventoryIcon from '@mui/icons-material/Inventory';
// import GroupAddIcon from '@mui/icons-material/GroupAdd';
// import { FaClipboardList, FaTasks } from "react-icons/fa";


// const SideDrawer = () => {
//     const location = useLocation();
//     const navigate = useNavigate();

//     const sideBarData = [
//         {
//             id: "manageUsers",
//             icon: <CreditCardIcon />,
//             label: "Create Invoice",
//             url: "/inventory/create-invoice",
//         },
//         {
//             id: "allApplicants",
//             icon: <PeopleAltIcon />,
//             label: "Manage User",
//             url: "/inventory/users",
//         },
//         {
//             id: "manageInvoice",
//             icon: <FaFileInvoice />,
//             label: "Manage Invoice",
//             url: "/inventory/manage-invoice",
//         },
//         {
//             id: "manageProduct",
//             icon: <InventoryIcon />,
//             label: "Manage Product",
//             url: "/inventory/manage-product",
//         },
//         {
//             id: "manageCustomer",
//             icon: <GroupAddIcon />,
//             label: "Manage Customer",
//             url: "/inventory/manage-customer",
//         },
//         {
//             id: "purchaseOrder",
//             icon: <FaClipboardList />,
//             label: "Purchase Order",
//             url: "/inventory/purchase-order",
//         },
//         {
//             id: "manageItem",
//             icon: <FaTasks />,
//             label: "Manage Purchase Item",
//             url: "/inventory/manage-purchase-item",
//         },
//         {
//             id: "managePurchaseOrder",
//             icon: <FaTasks />,
//             label: "Manage Purchase Order",
//             url: "/inventory/manage-purchase-order",
//         },
//         {
//             id: "manageDirectSales",
//             icon: <FaTasks />,
//             label: "Manage Direct Sales",
//             url: "/inventory/manage-diract-sales" ,
//         },
//          {
//             id: "manageIndirectSales",
//             icon: <FaTasks />,
//             label: "Manage Indirect Sales",
//             url: "/inventory/manage-indiract-sales" ,
//         }
//     ];

//     const handleNavigation = (url) => {
//         navigate(url);
//     };

//     return (
//         <Box
//             sx={{
//                 width: 265,
//                 flexShrink: 0,
//                 [`& .MuiDrawer-paper`]: {
//                     width: 240,
//                 },
//                 border: "none",
//             }}
//             className="border-0 h-full bg-[#0a3021]"
//             square
//         >
//             <Box sx={{ overflow: "auto" }}>
//                 <div className="flex flex-row justify-center items-center text-center pb-1">
//                     <img
//                         src={logo}
//                         className="w-[190px] h-[80px] object-cover pt-4"
//                         alt="Logo"
//                     />
//                 </div>
//                 {/* <Divider className="bg-[#ffffff]" /> */}
//                 <List>
//                     {sideBarData.map((item) => (
//                         <ListItem key={item.id}>
//                             <ListItemButton
//                                 onClick={() => handleNavigation(item.url)}
//                                 sx={{
//                                     backgroundColor:
//                                         location.pathname === item.url
//                                             ? "#105A3E"
//                                             : "transparent",
//                                     borderRadius: "4px",
//                                     "&:hover": {
//                                         backgroundColor: "#105A3E",
//                                     },
//                                 }}
//                             >
//                                 <item.icon.type
//                                     className={`${location.pathname === item.url
//                                         ? "text-white"
//                                         : "text-gray-100"
//                                         }`}
//                                 />
//                                 <ListItemText
//                                     primary={item.label}
//                                     className={`${location.pathname === item.url
//                                         ? "text-white"
//                                         : "text-gray-100"
//                                         } pl-2`}
//                                 />
//                             </ListItemButton>
//                         </ListItem>
//                     ))}
//                 </List>
//             </Box>
//         </Box>
//     );
// };

// export default SideDrawer;


import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import { useLocation, useNavigate } from "react-router-dom";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { Divider } from "@mui/material";
import { FaFileInvoice } from "react-icons/fa";
import logo from "../../../assets/inventory-logo.jpeg";
import InventoryIcon from '@mui/icons-material/Inventory';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { FaClipboardList, FaTasks } from "react-icons/fa";
import { FaFileInvoiceDollar, FaShoppingCart, FaStoreAlt } from "react-icons/fa";
import { LayoutDashboard } from "lucide-react";

const SideDrawer = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const sideBarData = [
        // {
        //     id: "dashboard",
        //     icon: <LayoutDashboard />,
        //     label: "Dashboard",
        //     url: "/inventory/dashboard",
        // },
        {
            id: "manageUsers",
            icon: <CreditCardIcon />,
            label: "Create Invoice",
            url: "/inventory/create-invoice",
        },
        {
            id: "allApplicants",
            icon: <PeopleAltIcon />,
            label: "Manage User",
            url: "/inventory/users",
        },
        {
            id: "manageInvoice",
            icon: <FaFileInvoice />,
            label: "Manage Invoice",
            url: "/inventory/manage-invoice",
        },
        {
            id: "manageProduct",
            icon: <InventoryIcon />,
            label: "Manage Product",
            url: "/inventory/manage-product",
        },
        {
            id: "manageCustomer",
            icon: <GroupAddIcon />,
            label: "Manage Customer",
            url: "/inventory/manage-customer",
        },
        {
            id: "purchaseOrder",
            icon: <FaClipboardList />,
            label: "Purchase Order",
            url: "/inventory/purchase-order",
        },
        {
            id: "manageItem",
            icon: <FaTasks />,
            label: "Manage Purchase Item",
            url: "/inventory/manage-purchase-item",
        },
        {
            id: "managePurchaseOrder",
            icon: <FaFileInvoiceDollar />,
            label: "Manage Purchase Order",
            url: "/inventory/manage-purchase-order",
        },
        {
            id: "manageDirectSales",
            icon: <FaShoppingCart />,
            label: "Manage Direct Sales",
            url: "/inventory/manage-diract-sales",
        },
        {
            id: "manageIndirectSales",
            icon: <FaStoreAlt />,
            label: "Manage Indirect Sales",
            url: "/inventory/manage-indiract-sales",
        },
    ];

    const handleNavigation = (url) => {
        navigate(url);
    };

    return (
        <Box
            sx={{
                width: 265,
                flexShrink: 0,
                height: "100vh",
                border: "none",
            }}
            className="bg-[#0a3021]"
            square
        >
            <Box sx={{ overflowY: "auto", height: "100%" }}> {/* scrollable if needed */}
                <div className="flex flex-row justify-center items-center text-center pb-1">
                    <img
                        src={logo}
                        className="w-[190px] h-[80px] object-cover pt-4"
                        alt="Logo"
                    />
                </div>
                <List>
                    {sideBarData.map((item) => (
                        <ListItem key={item.id}>
                            <ListItemButton
                                onClick={() => handleNavigation(item.url)}
                                sx={{
                                    backgroundColor:
                                        location.pathname === item.url
                                            ? "#105A3E"
                                            : "transparent",
                                    borderRadius: "4px",
                                    "&:hover": {
                                        backgroundColor: "#105A3E",
                                    },
                                }}
                            >
                                <item.icon.type
                                    className={`${location.pathname === item.url
                                        ? "text-white"
                                        : "text-gray-100"
                                        }`}
                                />
                                <ListItemText
                                    primary={item.label}
                                    className={`${location.pathname === item.url
                                        ? "text-white"
                                        : "text-gray-100"
                                        } pl-2`}
                                />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Box>
        </Box>
    );
};

export default SideDrawer;
